import { Card, Text, Link } from '@revdotcom/vaporwave';

import { type PageProps } from '../../codegen/PageProps';
import styles from '../../styles';

/**
 * Renders banner message or nothing, based on page props.
 * Controlled by the following view-data parameters:
 * - banner-text      - text to be rendered. the banner is not shown if not present/empty
 * - banner-link-text - link to be rendered under the text. requires banner-link-text
 * - banner-link-href - destination for the above link
 * @param {PageProps} props  theme props
 * @returns {Element} logo element
 */
export const Banner = (props: PageProps) => {
    const { viewData } = props;
    const bannerText = viewData['banner-text'];
    const bannerLinkText = viewData['banner-link-text'];
    const bannerLinkHref = viewData['banner-link-href'];

    if (!bannerText) return <></>;

    return (
        <Card sx={styles.cardBanner}>
            <Text sx={styles.cardBannerText}>{bannerText}</Text>
            {!!bannerLinkText && !!bannerLinkHref && (
                <Link
                    sx={styles.cardBannerLink}
                    href={bannerLinkHref}
                    target="_blank"
                    rel="noopener noreferer"
                >
                    {bannerLinkText}
                </Link>
            )}
        </Card>
    );
};
